<template>
  <div class="page-wrapper">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'EmptyView',
  components: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
}
</script>
<style scoped lang="less"></style>
